export const FILEDS_TYPE_INFO = {
  2: {
    mapField: 'TEXT',
  },
  3: {
    mapField: 'MOBILE_PHONE',
  },
  4: {
    mapField: 'TELEPHONE',
  },
  5: {
    mapField: 'EMAIL',
  },
  6: {
    mapField: 'NUMBER',
  },
  7: {
    mapField: 'CRED',
  },
  8: {
    mapField: 'MONEY',
  },
  9: {
    mapField: 'FLAT_MENU',
  },
  10: {
    mapField: 'MULTI_SELECT',
  },
  11: {
    mapField: 'DROP_DOWN',
  },
  14: { mapField: 'ATTACHMENT' },
  15: { mapField: 'DATE' },
  16: { mapField: 'DATE_TIME' },
  19: { mapField: 'AREA_PROVINCE' },
  21: { mapField: 'RELATION' },
  22: { mapField: 'SPLIT_LINE' },
  23: { mapField: 'AREA_CITY' },
  24: { mapField: 'AREA_COUNTY' },
  25: { mapField: 'MONEY_CN' },
  26: { mapField: 'USER_PICKER' },
  27: { mapField: 'DEPARTMENT' },
  28: { mapField: 'SCORE' },
  29: { mapField: 'RELATE_SHEET' },
  30: { mapField: 'SHEET_FIELD' },
  31: { mapField: 'FORMULA_NUMBER' },
  32: { mapField: 'CONCATENATE' },
  33: { mapField: 'AUTO_ID' },
  34: { mapField: 'SUB_LIST' },
  35: { mapField: 'CASCADER' },
  36: { mapField: 'SWITCH' },
  37: { mapField: 'SUBTOTAL' },
  38: { mapField: 'FORMULA_DATE' },
  40: { mapField: 'LOCATION' },
  41: { mapField: 'RICH_TEXT' },
  43: { mapField: 'OCR' },
  45: { mapField: 'EMBED' },
  46: { mapField: 'TIME' },
  47: { mapField: 'BAR_CODE' },
  48: { mapField: 'ORG_ROLE' },
  49: { mapField: 'SEARCH_BTN' },
  50: { mapField: 'SEARCH' },
};
